export function buildProductShareLink(productId: string, referrerId?: string | null): string {
  if (!productId || typeof window === 'undefined') return ''

  const params = new URLSearchParams()
  params.set('product_id', productId)
  if (referrerId) {
    params.set('referrer_id', referrerId)
  }

  return `${window.location.origin}/products?${params.toString()}`
}
